
export default function ContentArea({ children, small = false }) {
    const modifier = small ? "--small" : "";
    
    return <div className="content-area__wrapper">
        <div className={`content-area content-area${modifier}`}>
            {children}
        </div>
    </div>
}